export default __webpack_public_path__ + "static/LibreBaskerville-Regular-024779ef573f16e4898983a7ba989ebe.woff2";